import Constants              from "src/services/constants";
import { PrepareCallHandler } from "src/services/api";
import { Nullable           } from "src/common";


// #region Common
export enum ProductCounterStatusEnum {
  /** В очереди, ожидает обработки */
  PENDING = "pending",
  /** Обрабатывается в данный момент */
  PROCESSING = "processing",
  /** Обработка завершена, результат доступен */
  COMPLETED = "completed",
  /** Произошла ошибка при обработки */
  ERROR = "error"
}

export type Error = {
  /** Код ошибки */
  statusCode: number;
  /** Текст ошибки */
  error: string;
  /** Сообщение ошибки */
  message: string;
  /** Данные в ответ на ошибку */
  data: null;
};
// #endregion

// #region POST sveza/upload-image
export type UploadImageForCounterIn = FormData;

export type UploadImageForCounterOut = {
  ticket: string;
  status: ProductCounterStatusEnum;
  message: string;
  queue_position: number;
  estimated_wait_seconds: number;
};

export const uploadImageForCounter: PrepareCallHandler<
  UploadImageForCounterIn,
  UploadImageForCounterOut
> = (arg: UploadImageForCounterIn) => ({
  config: {
    url: `api/mobile/${Constants.API_VERSION}/sveza/upload-image`,
    method: "POST",
    data: arg,
    pwaLocked: "access",
    pwaRetry: false,
  },
});
// #endregion

// #region GET sveza/status/{ticket}
export type GetCounterStatusIn = {
  ticket: string;
};

/** Обработанное изображение */
export type GetCounterStatusOut = {
  completed_at: string;
  error_detail: string;
  estimated_wait_seconds: Nullable<number>;
  message: string;
  number_of_sheets: Nullable<number>;
  processed_image_url: Nullable<string>;
  processing_duration_ms: Nullable<number>;
  queue_position: Nullable<number>;
  status: ProductCounterStatusEnum;
  submitted_at: string;
  ticket: string;
};

export const getCounterStatus: PrepareCallHandler<
  GetCounterStatusIn,
  GetCounterStatusOut
> = (arg: GetCounterStatusIn) => ({
  config: {
    url: `api/mobile/${Constants.API_VERSION}/sveza/status/${arg.ticket}`,
    method: "GET",

    pwaLocked: "access",
    pwaRetry: false,
  },
});
// #endregion

// #region GET sveza/result/{ticket}
export type GetCounterResultIn = {
  ticket: string;
};

/** Обработанное изображение */
export type GetCounterResultOut = Blob;

export const getCounterResult: PrepareCallHandler<
  GetCounterResultIn,
  GetCounterResultOut
> = (arg: GetCounterResultIn) => ({
  config: {
    url: `api/mobile/${Constants.API_VERSION}/sveza/result/${arg.ticket}`,
    method: "GET",
    responseType: "blob",

    pwaLocked: "access",
    pwaRetry: false,
  },
});
// #endregion

// #region POST sveza/upload-fb-for-image
export type UploadFBForImageIn = FormData;

export type UploadFBForImageOut = null;

export const uploadFBForImage: PrepareCallHandler<
  UploadFBForImageIn,
  UploadFBForImageOut
> = (arg: UploadFBForImageIn) => ({
  config: {
    url: `api/mobile/${Constants.API_VERSION}/sveza/upload-fb-for-image`,
    method: "POST",
    data: arg,

    pwaLocked: "access",
    pwaRetry: false,
  },
});
// #endregion
